/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
// import VueMask from 'v-mask'
// Vue.use(VueMask)
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)


// import VSwitch from 'v-switch-case'

import StringMask from 'string-mask'
Vue.use(StringMask)

// import DropDownList from '@syncfusion/ej2-dropdowns'
// Vue.use(DropDownList)

import { QueryBuilderPlugin, ColumnsPlugin } from "@syncfusion/ej2-vue-querybuilder";
Vue.use(QueryBuilderPlugin);
Vue.use(ColumnsPlugin);

// import { DashboardLayoutPlugin } from '@syncfusion/ej2-vue-layouts'
// Vue.use(DashboardLayoutPlugin)

// import { SpreadsheetPlugin } from '@syncfusion/ej2-vue-spreadsheet';
// Vue.use(SpreadsheetPlugin);

// import { KanbanPlugin } from "@syncfusion/ej2-vue-kanban";
// Vue.use(KanbanPlugin);


// axios
import axios from './axios.js'
Vue.prototype.$http = axios

import { FIELD_TYPES, ICONS } from './helpers.js'
Vue.prototype.$FIELD_TYPES = FIELD_TYPES
Vue.prototype.$ICONS_LIST = ICONS

// Theme Configurations
import '../themeConfig.js'


// Firebase
// import '@/firebase/firebaseConfig'



// Auth0 Plugin
import AuthPlugin from './plugins/auth'
Vue.use(AuthPlugin)


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'

// Display label helper for i18n (modules, fields) - uses English when locale is 'en' and _en field exists
Vue.mixin({
  methods: {
    $displayLabel (item, field = 'title') {
      if (!item) return ''
      const enField = field + '_en'
      if (this.$i18n.locale === 'en' && item[enField]) return item[enField]
      return item[field] || ''
    }
  }
})


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)


// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'AIzaSyCyzYjniOcfheDBcGTpEc69HRsZOrCPtcc',
    libraries: 'places' // This is required if you use the Auto complete plug-in
  }
})

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')



// SSO

import { msalConfig } from './authConfig';
import { performFetch, decryptUuid, setApplicationLocalStorageItem } from './helpers.js'
import { PublicClientApplication } from '@azure/msal-browser';

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.handleRedirectPromise().then(async (response) => {
  if (response) {

    const accessToken = response.accessToken
    const expiresOn = response.expiresOn
    const user = response.account.username

    setApplicationLocalStorageItem('accessToken', accessToken)

    await performFetch(store.state.auth.api_url, {
      command: "register_microsoft_sso",
      parameters: {
        application_token: store.state.auth.app_token,
        'accessToken': accessToken,
        'expiresOn': expiresOn,
        'user': user
      }
    })
      .then(async response => {

        if (response.status === 200) {
          const jsonResponse = await response.json()
          await store.dispatch('auth/handleSuccessLogin', jsonResponse)
        } else {
          setApplicationLocalStorageItem('accessDenied', true)
          // await store.dispatch('auth/redirectToForbiddenPage')
        }
      })
      .catch(error => {
        setApplicationLocalStorageItem('accessDenied', true)
        // await store.dispatch('auth/redirectToForbiddenPage')
      })
  }
}).catch(error => {
  setApplicationLocalStorageItem('accessDenied', true)
});

// // Add msalInstance to Vue prototype to access it globally
Vue.prototype.$msal = msalInstance;


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
  // created() {
  //   const hash = window.location.hash;
  //   if(hash !== '') {
  //     this.$router.push('/home')
  //   }
  //   // console.log(hash)
  //   // if (hash && hash.includes('code=')) {
  //   //   // // Extract code or other necessary data from the fragment
  //   //   // const urlSearchParams = new URLSearchParams(hash.substring(1)); // Remove '#' and parse
  //   //   // const params = Object.fromEntries(urlSearchParams.entries());
  //   //   // const code = params.code; // or other data you need

  //   //   // // Handle the extracted code
  //   //   // this.handleAuthCode(code);

  //   //   // window.history.replaceState({}, document.title, window.location.pathname);
  //   // }
  // }
}).$mount('#app')
